import { spawn, call, takeLatest, put, all } from 'redux-saga/effects';

// Actions
import { validarDesafioTcooAction } from '../../../../application/actions/validarDesafioTcoo';

import { loadersActions } from '../../../../application/actions/ui_loaders';

import api from '../../../api';
const apiValidarDesafioTcoo = api(process.env.REACT_APP_URL);

export function* fetchValidarTcco(datos) {
  try {
    const {  coordenadas , trackid, autorizacion } = datos.payload;

    const pullCoordenadas = {
        "valores": [ coordenadas[0], coordenadas[1], coordenadas[2]]
    }
    // Cambio de estado al action loader a true
    yield put(loadersActions.changeStatusLoaderValidarTcoo({ isLoading: true }));

    //Hacemos la llamada al servicio
    const { data } = yield call(apiValidarDesafioTcoo.post,'/desafio/coordenadas/validar', pullCoordenadas  , { 
        'Track-Id': trackid,
        'Authorization': autorizacion
     });
     

    yield put(loadersActions.changeStatusLoaderValidarTcoo({ isLoading: false }));


    if (data) {
      yield put(validarDesafioTcooAction.fetchValidarDesafioTcooSuccess({ respuestaServicio: data }));
    } else {
      yield put(validarDesafioTcooAction.fetchValidarDesafioTcooError());

    }

  } catch {
      //Errores
    yield all([
      put(validarDesafioTcooAction.fetchValidarDesafioTcooError())
    ]);
  }
}

export function* watchFetchValidarTcco() {
  yield takeLatest(validarDesafioTcooAction.fetchValidarDesafioTcoo.type, fetchValidarTcco);
}

export default function* rootSaga() {
  yield spawn(watchFetchValidarTcco);
}
